import type {ColorResult} from 'react-color';

const formatColorResult = (color: ColorResult) => {
  return `rgba(${Object.values(color.rgb).join(',')})`;
};

export default formatColorResult;
